/* eslint-disable no-unused-vars */
import React, {
  Component,
  useContext,
  useRef,
  useCallback,
  useEffect,
} from 'react';
// import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */
import survey from '../../../context/survey';
import sendRAT, { ACTION, SCREEN } from '../../../app/rat';
// import Inquiry from '../../inquiry/Inquiry';
import surveyState from '../../../app/surveyState';
import { InquiryMotion } from '../style';
import { Broadcast } from '../../../../../embedded-type/broadcast';
import { usePrevious } from '../../../../../embedded-type/hooks';

/**
 * {@link Inquiry} 出現を条件により切替えます
 * @param {number} index widget index number - 0 の時は animation 無し
 * @param {boolean} embedded embedded flag - embedded && desktop: fadein
 * @param {boolean} desktop resize desktop flag - embedded && desktop: fadein
 * @param {*} config React.Context.[survey|config].state.config
 * @param {function} onCloseClick close button click callback
 * @param {function} onSendClick submit button click callback
 * @param {*} state React.Context.[survey|config].state
 * @param {function} dispatch React.Context.[survey|config].dispatch
 * @return {*} React.node
 * @constructor
 */
const InquiryComponent = ({
  index,
  embedded,
  desktop,
  config,
  onCloseClick,
  onSendClick,
  state,
  dispatch,
}) => {
  const modeRef = useRef('');
  const prevMode = usePrevious(modeRef.current);
  // console.log('InquiryComponent', embedded, desktop, modeRef.current, '/', prevMode)
  // resize で animation が発動しないようにする
  let motion = '';
  if (modeRef.current === prevMode || prevMode === '') {
    // console.log('InquiryComponent - default')
    // return (
    //   <Inquiry
    //     config={config}
    //     onCloseClick={onCloseClick}
    //     onSendClick={onSendClick}
    //     state={state}
    //     dispatch={dispatch}
    //     embedded={embedded}
    //   />
    // );
    motion = 'none';
  } else if (index === 0) {
    // console.log('InquiryComponent - normal')
    modeRef.current = 'normal';
    // return (
    //   <Inquiry
    //     config={config}
    //     onCloseClick={onCloseClick}
    //     onSendClick={onSendClick}
    //     state={state}
    //     dispatch={dispatch}
    //     embedded={embedded}
    //   />
    // );
    motion = 'none';
  } else if (embedded && desktop) {
    // console.log('InquiryComponent - fadein')
    modeRef.current = 'fadein';
    // return (
    //   <FadeinInquiryComponent
    //     config={config}
    //     onCloseClick={onCloseClick}
    //     onSendClick={onSendClick}
    //     state={state}
    //     dispatch={dispatch}
    //     embedded={embedded}
    //   />
    // );
    motion = 'in';
  } else {
    // console.log('InquiryComponent - fadein-up')
    modeRef.current = 'fadein-up';
    // return (
    //   <FadeinUpInquiryComponent
    //     config={config}
    //     onCloseClick={onCloseClick}
    //     onSendClick={onSendClick}
    //     state={state}
    //     dispatch={dispatch}
    //     embedded={embedded}
    //   />
    // );
    motion = 'up';
  }

  // 同一 component で motion 切替を行わないと child component が初期化される
  return (
    <InquiryMotion
      config={config}
      onCloseClick={onCloseClick}
      onSendClick={onSendClick}
      state={state}
      dispatch={dispatch}
      embedded={embedded}
      motion={motion}
    />
  );
};
/**
 * widget Inquiry
 * - 表示に RAT `appear` 送信します
 * @param {number} index 表示順序 config.step 等価の時に表示します
 * @param {function} onSendClick 送信ボタン callback
 * @param {*} state React.Context survey.state
 * @param {function} dispatch React.Context survey.dispatch
 * @param {boolean} [embedded=false] React.Context.survey.state.config.embedded - 埋め込みフラッグ
 * @param {boolean} [desktop=false] resize desktop flag - animation 種類切替えに使用します
 * @return {*} React.node - Inquiry
 * @constructor
 */
const WidgetInquiry = ({
  index,
  onSendClick,
  state,
  dispatch,
  embedded = false,
  desktop = false,
}) => {
  // /**
  //  * state {object} - {@link config}.reduce 戻り値
  //  * dispatch {function} - {@link config}.Context state 変更関数 - type 指定を行います
  //  */
  // const { state, dispatch } = useContext(survey.Context);

  const { config, step } = state;

  // didUpdate
  useEffect(() => {
    if (step === index) {
      // RAT for appear
      sendRAT({
        cId: config.cId.value,
        screen: SCREEN.INQUIRY,
        action: ACTION.APPEAR,
      });
    }
  }, [step, config.cId.value, index]);

  const onCloseClick = useCallback(() => {
    // sendRAT - cId, screen: SCREEN.INQUIRY `inquiry`, action: ACTION.CLOSE `close`
    sendRAT({
      cId: config.cId.value,
      screen: SCREEN.INQUIRY,
      action: ACTION.CLOSE,
    });

    // /rexsurvey_save_state=false/.test(window.location.search) === false -> 「Surveyへの回答を拒否した」という状態をLocalStorageに保存する - declineSurvey
    if (surveyState.shouldStoreState()) {
      surveyState.storeDecline(
        config.expirationPeriod,
        config.enableDisplaySuppressionPerPage
      );
    }
    // close all: step: -1
    state.type = survey.events.UPDATE;
    state.step = -1;
    dispatch(state);
    // Redux.store.submit
    if (embedded) {
      Broadcast.submit.close();
    }
  }, [state, dispatch, config, embedded]);

  // // component 選択します
  // // index: 0 - static / animation (fadeInUp)
  // const InquiryComponent =
  //   index === 0
  //     ? Inquiry
  //     : embedded
  //     ? FadeinInquiryComponent
  //     : FadeinUpInquiryComponent;

  return (
    step === index && (
      <InquiryComponent
        index={index}
        embedded={embedded}
        desktop={desktop}
        config={config}
        onCloseClick={onCloseClick}
        onSendClick={onSendClick}
        state={state}
        dispatch={dispatch}
      />
    )
  );
};

export default WidgetInquiry;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/widget/sequences/WidgetInquiry.js